import {types} from '../../types';

const setGetInformationUsersAction = (payload) => {
    return {
        type: types.information.SET_USERS_MOBILE,
        payload,
      }
}

const setGetInformationSpinAction = (payload) => {
  return {
    type: types.information.SET_SPIN_MOBILE,
    payload
  }
}

const setGetDetalizationSpinAction = (payload) => {
  return {
    type: types.information.SET_DETALIZATION_SPIN_MOBILE,
    payload
  }
}

const setGetDetalizationAction = (payload) => {
  return {
    type: types.information.SET_DETALIZATION_MOBILE,
    payload
  }
}

const setGetNewUsersAction = (payload) => {
  return {
    type: types.information.SET_NEW_USERS_MOBILE,
    payload
  }
}

const setGetCountOnlineAction = (payload) => {
  return {
    type: types.information.SET_COUNT_ONLINE_MOBILE,
    payload
  }
}

export {
  setGetInformationUsersAction as SetGetInformationUsersAction,
  setGetInformationSpinAction as SetGetInformationSpinAction,
  setGetDetalizationSpinAction as SetGetDetalizationSpinAction,
  setGetDetalizationAction as SetGetDetalizationAction,
  setGetNewUsersAction as SetGetNewUsersAction,
  setGetCountOnlineAction as SetGetCountOnlineAction
}